"use client";
import { jsx } from "react/jsx-runtime";
import { useImageConfig } from "../../../utils/ImageConfigProvider/ImageConfigProviderClient.js";
import { getSwappedImageDomainUrl } from "../../../utils/images/lib.js";
import { Link } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../Analytics/index.js";
function renderIconImage(entry, imageDomainSwapConfig) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const originalSrc = ((_b = (_a = entry == null ? void 0 : entry.icon_image) == null ? void 0 : _a[0]) == null ? void 0 : _b.url) ? (_d = (_c = entry == null ? void 0 : entry.icon_image) == null ? void 0 : _c[0]) == null ? void 0 : _d.url : (_e = entry.icon) == null ? void 0 : _e.url;
  const swappedSrc = getSwappedImageDomainUrl(
    originalSrc,
    imageDomainSwapConfig
  );
  if ((_f = entry.icon) == null ? void 0 : _f.dimension) {
    return /* @__PURE__ */ jsx(
      "img",
      {
        alt: entry.link_alt_text,
        loading: "lazy",
        src: swappedSrc,
        height: ((_h = (_g = entry.icon_image) == null ? void 0 : _g[0]) == null ? void 0 : _h.dimensions.height) ? (_j = (_i = entry.icon_image) == null ? void 0 : _i[0]) == null ? void 0 : _j.dimensions.height : (_k = entry.icon) == null ? void 0 : _k.dimension.height,
        width: ((_m = (_l = entry.icon_image) == null ? void 0 : _l[0]) == null ? void 0 : _m.dimensions.width) ? (_o = (_n = entry.icon_image) == null ? void 0 : _n[0]) == null ? void 0 : _o.dimensions.width : (_p = entry.icon) == null ? void 0 : _p.dimension.width
      }
    );
  } else {
    return /* @__PURE__ */ jsx("img", { alt: entry.link_alt_text, loading: "lazy", src: swappedSrc });
  }
}
function IconOnly({
  entry,
  externalLinkData,
  target
}) {
  var _a, _b, _c, _d;
  const { imageDomainSwapConfig } = useImageConfig();
  if (!entry) return null;
  const hasExternalLinkWarning = !!((_a = entry.link) == null ? void 0 : _a.external_site);
  const isPreserveSearchParms = !!entry.preserve_url_params;
  const {
    warningPrimaryButtonText,
    warningCloseButtonAriaLabelText,
    warningSecondaryButtonText,
    warningText,
    warningTitle
  } = externalLinkData || {};
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        component: {
          trackedData: [(_b = entry.link) == null ? void 0 : _b.title]
        }
      },
      children: /* @__PURE__ */ jsx(
        Link,
        {
          "aria-label": entry.link_alt_text,
          dataPrivate: entry == null ? void 0 : entry.disable_third_party_tracking,
          hasExternalLinkWarning,
          href: (_c = entry.link) == null ? void 0 : _c.url,
          preserveSearchParams: isPreserveSearchParms,
          target,
          uniqueId: (_d = entry.link) == null ? void 0 : _d.title,
          warningCloseAriaLabel: warningCloseButtonAriaLabelText,
          warningPrimaryButtonText,
          warningSecondaryButtonText,
          warningText,
          warningTitle,
          children: entry.icon && renderIconImage(entry, imageDomainSwapConfig)
        }
      )
    }
  );
}
export {
  IconOnly
};
